module.exports = __webpack_public_path__ + "media/images/athletes/2213-3044f0ff71838cf650820e883525162f.png";